'use strict';

import { NewIamHelper } from '../../../shared/components/helpers';

angular.module('userRequestArrivalControllers')

.controller('RequestArrivalController', ['$scope', '$state', '$stateParams', '$translate', 'topBar', 'userRequestArrivalService', 'userAccessRequestService', 'authenticatedUser', 'userRequest', 'lookups', function ($scope, $state, $stateParams, $translate, topBar, userRequestArrivalService, userAccessRequestService, authenticatedUser, userRequest, lookups) {

    $scope.authenticatedUser = authenticatedUser;
    $scope.userRequest = userRequest;
    $scope.lookups = lookups;

    // Top bar
    $translate('iam.userRequest.userRequestArrival.pageTitle', {requestId: userRequest.UserAccessRequestID}).then(function(translation) {
        topBar.setTitleAndIcon(translation, 'fa-inbox');
    });

    // With response on box
    $scope.withResponseBox = function (boxName) {
        if (boxName === 'OfficeLocation') {
            return !_.isEmpty($scope.userRequest.OfficeLocation) && !$scope.isUpdating(boxName);
        }
        else if (boxName === 'ComputingDevice') {
            return _.isNumber($scope.userRequest.ComputingDeviceLookupID) && !$scope.isUpdating(boxName);
        }
        else if (boxName === 'OtherEquipments') {
            if ($scope.isUpdating(boxName)) return false;

            return _.isBoolean($scope.userRequest.WithLandlinePhoneWithVoicemail) &&
                   _.isBoolean($scope.userRequest.WithDedicatedLocalPrinter) &&
                   _.isBoolean($scope.userRequest.WithExternalNetworkAccess);
        }
        else if (boxName === 'Permissions') {
            if ($scope.isUpdating(boxName)) return false;

            return !_.isEmpty($scope.userRequest.ExplanationComments);
        }
    }

    // When updating
    $scope.setUpdating = function (boxName) {
        $scope.ctx.updating = boxName;
    }

    $scope.noUpdating = function () {
        $scope.ctx.updating = undefined;
    }

    $scope.isUpdating = function (boxName) {
        return $scope.ctx.updating === boxName;
    }

    // Focus on box
    $scope.setFocusOnBox = function (boxName) {
        $scope.ctx.focusOnBox = boxName;
        $scope.ctx.showBox[boxName] = true;
    }

    $scope.focusOnBox = function (boxName) {
        return $scope.ctx.focusOnBox === boxName;
    }

    // To show box
    $scope.showBox = function (boxName) {
        return $scope.ctx.showBox[boxName];
    }

    // Set Initial Context
    $scope.ctx = {};
    $scope.ctx.showBox = {
        'OfficeLocation': true,
        'ComputingDevice': $scope.withResponseBox('OfficeLocation'),
        'OtherEquipments': $scope.withResponseBox('ComputingDevice'),
        'Permissions': $scope.withResponseBox('OtherEquipments')
    };

    if ($scope.withResponseBox('Permissions')) $scope.ctx.focusOnBox = 'Permissions';
    else if ($scope.withResponseBox('OtherEquipments')) $scope.ctx.focusOnBox = 'Permissions';
    else if ($scope.withResponseBox('ComputingDevice')) $scope.ctx.focusOnBox = 'OtherEquipments';
    else if ($scope.withResponseBox('OfficeLocation')) $scope.ctx.focusOnBox = 'ComputingDevice';
    else $scope.ctx.focusOnBox = 'OfficeLocation';

    // Manage Computing Device
    $scope.isSelectedComputingDevice = function (computingDevice) {
        return $scope.userRequest.ComputingDeviceLookupID === computingDevice.ComputingDeviceLookupID;
    }

    $scope.updateComputingDeviceResponse = function (computingDevice) {
        if (!$scope.userRequest.IsDraft) return;

        $scope.userRequest.ComputingDeviceLookupID = computingDevice.ComputingDeviceLookupID;
        $scope.setUpdating('ComputingDevice');
    }

    // Other equipments
    $scope.setWithLandlinePhoneWithVoicemail = function (response) {
        if (!$scope.userRequest.IsDraft) return;

        $scope.userRequest.WithLandlinePhoneWithVoicemail = response;
        $scope.setUpdating('OtherEquipments');
    };

    $scope.setWithDedicatedLocalPrinter = function (response) {
        if (!$scope.userRequest.IsDraft) return;

        $scope.userRequest.WithDedicatedLocalPrinter = response;
        $scope.setUpdating('OtherEquipments');
    };

    $scope.setWithExternalNetworkAccess = function (response) {
        if (!$scope.userRequest.IsDraft) return;

        $scope.userRequest.WithExternalNetworkAccess = response;
        $scope.setUpdating('OtherEquipments');
    };

    $scope.allRequiredFieldsForOtherEquipments = function () {
        return !_.isUndefined($scope.userRequest.WithLandlinePhoneWithVoicemail) &&
               !_.isUndefined($scope.userRequest.WithDedicatedLocalPrinter) &&
               !_.isUndefined($scope.userRequest.WithExternalNetworkAccess)
    }

    // Save request
    var saveRequest = function () {
        if (!$scope.userRequest.IsDraft) return;

        return userAccessRequestService.updateInfosForArrivalEvent($scope.userRequest)
                .then(function (updatedRequest) {
                    $scope.userRequest = updatedRequest;
                });
    }

    $scope.saveRequestForBox = function (boxName) {
        if (!$scope.userRequest.IsDraft) return;

        return saveRequest()
            .then(function () {
                $scope.noUpdating();
                if (boxName === 'OfficeLocation') $scope.setFocusOnBox('ComputingDevice');
                else if (boxName === 'ComputingDevice') $scope.setFocusOnBox('OtherEquipments');
                else if (boxName === 'OtherEquipments') $scope.setFocusOnBox('Permissions');
            });
    }

    // Submit request
    $scope.submitRequest = function () {
        if (!$scope.userRequest.IsDraft) return;

        $scope.saveRequestForBox('Permissions')
        .then(function () {
            return userRequestArrivalService.request.submit($scope.userRequest.UserAccessRequestID);
        })
        .then(function () {
            setTimeout(() => NewIamHelper.navigateTo('profile.employee', $scope.userRequest.EmployeeID), 1000);
        });
    }

    // Cancel request
    $scope.cancelRequest = function () {
        if (!$scope.userRequest.IsDraft) return;

        userRequestArrivalService.request.cancel($scope.userRequest.UserAccessRequestID)
        .then(function () {
            setTimeout(() => NewIamHelper.navigateTo('profile.employee', $scope.userRequest.EmployeeID), 1000);
        });
    }

}]);
